import { computed, type CSSProperties, type Ref } from "vue";

import { useMediaQuery } from "@/lib/composables/media-query";

import { type DrawerVariant, useDrawerVariant } from "./Portal";

const FIT_QUERY = "(width >= 640px)";
const RESERVE_QUERY = "(width >= 1024px)";

const DRAWER_WIDTH_PX: Record<DrawerVariant, number> = {
  default: 480,
  "very-wide": 800,
};

export const useReservesDrawerSpace = (): Ref<boolean> =>
  useMediaQuery(RESERVE_QUERY);

export const useDrawerSurface = (): Ref<{
  class: string;
  style: CSSProperties;
}> => {
  const variant = useDrawerVariant();
  const fits = useMediaQuery(FIT_QUERY);
  const reserves = useMediaQuery(RESERVE_QUERY);

  return computed(() => {
    const fitsAtCurrentWidth =
      variant.value === "very-wide" ? reserves.value : fits.value;
    if (!fitsAtCurrentWidth) {
      return { class: "w-full", style: {} };
    }
    return {
      class: "border-l",
      style: { width: `${DRAWER_WIDTH_PX[variant.value]}px` },
    };
  });
};

export const drawerOffsetStyle = (variant: DrawerVariant): CSSProperties => ({
  marginRight: `${DRAWER_WIDTH_PX[variant]}px`,
});
